module.exports = __webpack_public_path__ + "static/img/girl-03.f021639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/girl-03.jpg
// module id = Mgk9
// module chunks = 0